/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ByChannelRequestBuilderRequestsMetadata, type ByChannelRequestBuilder } from './byChannel/index.js';
// @ts-ignore
import { MtdRequestBuilderRequestsMetadata, type MtdRequestBuilder } from './mtd/index.js';
// @ts-ignore
import { RhythmRequestBuilderRequestsMetadata, type RhythmRequestBuilder } from './rhythm/index.js';
// @ts-ignore
import { SummaryRequestBuilderRequestsMetadata, type SummaryRequestBuilder } from './summary/index.js';
// @ts-ignore
import { TrendRequestBuilderRequestsMetadata, type TrendRequestBuilder } from './trend/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/orders
 */
export interface OrdersRequestBuilder extends BaseRequestBuilder<OrdersRequestBuilder> {
    /**
     * The byChannel property
     */
    get byChannel(): ByChannelRequestBuilder;
    /**
     * The mtd property
     */
    get mtd(): MtdRequestBuilder;
    /**
     * The rhythm property
     */
    get rhythm(): RhythmRequestBuilder;
    /**
     * The summary property
     */
    get summary(): SummaryRequestBuilder;
    /**
     * The trend property
     */
    get trend(): TrendRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const OrdersRequestBuilderUriTemplate = "{+baseurl}/api/analytics/orders";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const OrdersRequestBuilderNavigationMetadata: Record<Exclude<keyof OrdersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byChannel: {
        requestsMetadata: ByChannelRequestBuilderRequestsMetadata,
    },
    mtd: {
        requestsMetadata: MtdRequestBuilderRequestsMetadata,
    },
    rhythm: {
        requestsMetadata: RhythmRequestBuilderRequestsMetadata,
    },
    summary: {
        requestsMetadata: SummaryRequestBuilderRequestsMetadata,
    },
    trend: {
        requestsMetadata: TrendRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
